<template>
    <div class="outer">
        
        <div class="topSearch">
            <!-- <el-form class="queryRow" inline>
                <el-form-item label="部门类别" class="queryCol">
                    <el-select v-model="queryForm.category">
                        <el-option value="商务">商务</el-option>
                        <el-option value="行政">行政</el-option>
                    </el-select>
                </el-form-item>
            </el-form> -->
            <div>
                {{ categoryTitle }}
            </div>
            <el-button type="primary" icon="el-icon-plus" @click="addFatherNode">
                新增一级分类
            </el-button>
        </div>

        <el-table
        ref="table"
        class="table"
        :data="tableData"
        style="height: 80vh;overflow: auto;"
        row-key="id"
        :tree-props="{children: 'children'}">
            <template slot="empty">
                <el-empty :image-size="150"></el-empty>
            </template>
            <el-table-column
                align="left"
                width="250"
                label="分类名称"
                prop="goodsClassName">
            </el-table-column>
            <el-table-column
                align="center"
                label="类型"
                prop="type">
                <template slot-scope="scope">
                    <el-tag effect="dark" v-if="scope.row.classLevel === 1">
                        一级分类
                    </el-tag>
                    <el-tag v-else>
                        二级分类
                    </el-tag>
                </template>  
            </el-table-column>
            <el-table-column
                label="操作"
                width="300"
                align="center"
                prop="operate">
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-plus" v-if="scope.row.classLevel === 1" @click="addChildrenNode(scope.row,scope.row.classLevel + 1)">新增二级分类</el-button>
                    <el-button type="text" icon="el-icon-edit" @click="editNode(scope.row.id,scope.row.goodsClassName)">修改</el-button>
                    <el-button type="text" icon="el-icon-delete" style="color: #F56C6C" @click="delNode(scope.row,scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

    </div>
</template>
<script>
import { del } from 'vue';
import { getGoodsClassList, getGoodsByPage, insertGoodsClass, deleteGoodsClass, updateGoodsClass } from '@/api/goods/goodsBusiness.js';
export default {
    data() {
      return { // 表格数据
        queryForm: {
            classFlag: sessionStorage.getItem('userRoleId'), // 分类类型 1 商务 2 行政
        },
        tableData: [],
        fatherNodeDialog: false,
        categoryTitle: '', // 页面标题
        category: '', // 分类类型 商务 行政
      }
    },
    created(){
        let roleId = sessionStorage.getItem('userRoleId');
        if(roleId == 28){
            this.categoryTitle = '商务采购货物分类';
            this.queryForm.classFlag = '1';
            this.category = "商务";
        }else if(roleId == 1 || roleId == 48 || roleId == 31){// 行政采购货物分类(1:admin, 48:行政总监, 31:行政人员)
            // roleId:
            // 48 || 31  行政&行政主管
            // 27 财务
            this.categoryTitle = '行政采购货物分类'; 
            this.queryForm.classFlag = '2';
            this.category = "行政";
        }
        this.getGoodsCategory();
    },
    computed:{
        
    },
    methods:{

        // 获取货物分类列表
        getGoodsCategory(){
            getGoodsClassList(this.queryForm).then((res) => {
                if(res.code === 200){
                    this.tableData = res.data
                }
            })
        },
        
        // 添加父节点
        addFatherNode(){
            this.$prompt('分类名称', '新增一级分类', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: /[^ \x20]+/,
            inputErrorMessage: '分类名称为空',
            }).then(({ value }) => {
                this.addGoodsClass({
                    goodsClassName: value,
                    classLevel: 1,
                    category: this.queryForm.classFlag === '1' ? "商务" : "行政",
                    parentClassCode: null,
                })
            })
        },

        // 添加子节点
        addChildrenNode(row,classLevel){
            this.$prompt('分类名称', '新增二级分类', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: /[^ \x20]+/,
            inputErrorMessage: '分类名称为空'
            }).then(({ value }) => {
                this.addGoodsClass({
                    goodsClassName: value,
                    classLevel: classLevel,
                    category: this.queryForm.classFlag === '1' ? "商务" : "行政",
                    parentClassCode: row.goodsClassCode,
                })
                
                setTimeout(() => {
                    this.$refs.table.toggleRowExpansion(row, true);
                }, 100);

            })
        },

        //修改节点
        editNode(id, goodsClassName){
            this.$prompt('分类名称', '修改节点', {
            inputValue: goodsClassName,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: /[^ \x20]+/,
            inputErrorMessage: '分类名称为空'
            }).then(({ value }) => {
                updateGoodsClass({
                    id,
                    goodsClassName:value,
                }).then((res) => {
                    if(res.code === 200){
                        this.getGoodsCategory();
                        this.$message({
                            type: 'success',
                            message: '修改成功',
                        });
                    }
                })
            })
        },

        addGoodsClass(obj){
            insertGoodsClass(obj).then((res) => {
                if(res.code === 200){
                    this.getGoodsCategory();
                    this.$message({
                        type: 'success',
                        message: '新增成功'
                    });

                } 
            });
        },
        // 删除父节点
        delNode(row,id){
            let delArr = [id];
            if(row.children){
                this.$message({
                    type: 'warning',
                    message: '请先删除该分类下的所有二级分类',
                })
                    // // 递归获取子类id列表
                    // function getChildrenId(children){
                    //     children.forEach(item => {
                    //         delArr.push(item.id)
                    //         if(item.children){
                    //             getChildrenId(item.children);
                    //         }
                    //     })
                    // }
                    // getChildrenId(row.children);
            }else{
                this.$confirm('确定删除该分类', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    getGoodsByPage({
                        goodsClassCode: row.goodsClassCode,
                        category: this.category,
                        page: 1,
                        limit: 10,
                    }).then((res) => {
                        if(res.code === 200){
                            if(res.total > 0){
                                this.$message({
                                    type: 'warning',
                                    message: '该分类下有货物，不能删除',
                                });
                                return;
                            }

                            this.delGoodsClass(delArr);
                        }
                    })
                    
                })
            } 
        },
        // 删除货物分类
        delGoodsClass(delArr){

            deleteGoodsClass(delArr).then((res) => {
                if(res.code === 200){
                    this.getGoodsCategory();
                    this.$message({
                        type: 'success',
                        message: '删除成功!',
                    });
                }
            })
        },
    },
}
</script>
<style lang="scss" scoped>
.outer{

    .topSearch{
        display: flex;
        justify-content: space-between;
        margin-bottom: 15px;
        align-items: center;
    }
    .queryRow {
        overflow: hidden;
        margin-bottom: 20px;
        display: flex;
        .queryName {
            width: 300px;
            margin-right: 10px;
        }

        .dataPicker {
            margin-right: 10px;
        }
    }

    .table{
        ::v-deep .el-table__expanded-cell{
            padding: 0
        }

        &::before{
            display: none;
        }
    }
    
}

</style>
